<script>

import AkLabel from "@components/general/AkLabel";
import utilsMixin from "@mixins/utilsMixin";

export default {
  components: {AkLabel},
  mixins: [utilsMixin],
  inject: {'pSubmitted': {default: null}, 'pDisabled': {default: null}},
  props: {
    modelValue: {},
    errorValue: {},
    label: {
      type: String,
      required: false,
    },
    accept: {
      type: String,
      required: false,
    },
    className: {
      type: String,
      required: false,
      default: "col-md-4 col-6"
    },
    disabled: {
      type: Boolean,
      required: false,
      default: undefined
    },
    fileLimit: {
      type: Number,
      required: false,
      default: null
    },
    maxFileSize: {
      type: Number,
      required: false,
      default: 100000000
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  methods: {
    selectFiles(event) {
      this.currentValue = event.files;
    },
    removeFile(event) {
      this.currentValue = event.files;
    },
    clearFiles() {
      this.currentValue = [];
    },
    clear() {
      this.$refs.file.clear();
    },
    uploader(event) {
      this.currentValue = event.files;
    },
    addSizeFilesMessage(message) {
      if (this.$refs.file?.messages) {
        // Si un message d'erreur similaire existe déjà, on le supprime
        this.$refs.file.messages = this.$refs.file.messages.filter(msg => !msg.includes('dépasse la limite autorisée'));

        // Ajoute le nouveau message d'erreur
        this.$refs.file.messages.push(message);
      }
    },
  },
  computed: {
    currentValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    },
    currentErrorValue: {
      get() {
        return this.errorValue;
      },
      set(val) {
        this.$emit('update:errorValue', val);
      }
    },
    isDisabled() {
      if (this.disabled !== undefined) return this.disabled;
      if (this.pDisabled !== undefined) return this.pDisabled;
      return false;
    },
    size() {
      if (this.currentValue && this.currentValue.length > 0) {
        return this.currentValue.reduce((acc, file) => acc + file.size, 0);
      }
      return 0;
    },
  },
  watch: {
    size(newSize) {
      // Vérifie si la taille totale des fichiers dépasse la limite autorisée
      if (newSize > this.maxFileSize) {
        const message = `La taille totale des fichiers sélectionnés (${this.formatBytesDecimal(newSize)}) dépasse la limite autorisée (${this.formatBytesDecimal(this.maxFileSize)})`;
        this.addSizeFilesMessage(message);
      } else {
        // Si la taille est inférieure ou égale à la limite, on supprime le message d'erreur
        this.$refs.file?.messages?.forEach((msg, index) => {
          if (msg.includes('dépasse la limite autorisée')) {
            this.$refs.file.messages.splice(index, 1);
          }
        });
      }
    },
    currentValue() {
      this.currentErrorValue = this.size > this.maxFileSize || (this.fileLimit && this.currentValue && this.currentValue.length > this.fileLimit)
    }
  }
}
</script>

<template>
  <div :class="this.className" class="form-group">
    <AkLabel>{{ this.label }} (limite de taille pour la somme de tous les fichiers: {{ this.formatBytesDecimal(this.maxFileSize) }})</AkLabel>
    <FileUpload ref="file"
                name="file"
                :chooseLabel="$t('choose_file')"
                :cancelLabel="$t('cancel_file')"
                :multiple=multiple
                :disabled="isDisabled"
                :showUploadButton=false
                :customUpload="true"
                :fileLimit="fileLimit"
                :maxFileSize="maxFileSize"
                invalidFileSizeMessage="{0}: Taille de fichier invalide. La taille devrait être plus petite que {1}"
                :accept="accept"
                @select=selectFiles
                @remove=removeFile
                @clear=clearFiles
                @uploader=uploader>
      <template #empty>
        <p>{{ $t('drag_files') }}</p>
      </template>
    </FileUpload>
  </div>
</template>